/**
 * 商户卖车记录
 */
import React from 'react';
import { Row, Col, DatePicker, Input, Tooltip, Icon, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';
//车辆评估详细
import FastSellDetail from './FastSellDetail';
//极速卖车跟进记录
import FastSellRecord from './FastSellRecord';
import { global_data } from '../../ui/auth'

class FastSellIndex extends React.Component {

    columns = [
    {
        title: '车辆名称',
        dataIndex: 'name',
        width: '20%',
    }
    , {
        title: '车主电话',
        dataIndex: 'tel',
        width: '10%',
    }
    , {
        title: '卖车时间',
        dataIndex: 'sellTime',
        width: '10%',
    }, {
        title: '提交时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '来源',
        dataIndex: 'source',
        width: '10%',
        format: { 0: "商城首页", 1: "朋友圈广告", 2: "微信分享" }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("FAST_SELL_LOG_FELLOW")?
                <Tooltip title="添加跟进记录">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.addRecord.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        loadingVisible: false,    //导出遮罩

        detailVisible: false,
        detailData: {},
    };

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/fastSell/download',
            data: queryData,
            fileName: "极速卖车记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    detail = (info, e) => {
        this.refs["detail"].loadRecord(info.id);
        this.setState({ detailData: info, detailVisible: true });
        // if (info.licenseImg != null && info.licenseImg !== "") {
        //     http.post({
        //         url: '/common/getThumbnailImage',
        //         data: {
        //             url: info.licenseImg
        //         },
        //         success: (res) => {
        //             let image = { "licenseImg": res };
        //             info["image"] = image;
        //             this.setState({ detailData: info, detailVisible: true });
        //         }
        //     });
        // } else {
        //     this.setState({ detailData: info, detailVisible: true });
        // }
    }

    //添加极速卖车记录
    addRecord = (info, e) => {
        this.setState({ editData: info, visible: true });
    }


    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/fastSell/findFastSellPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <FastSellDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, detailData: {} }); }}
                    editData={this.state.detailData}
                    ref="detail"
                />
                <FastSellRecord
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }); }}
                    editData={this.state.editData}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default FastSellIndex;